/** @namespace pageTransitions */
export default {
  backward: "backward",
  forward: "forward",
  modalPageUp: "modal-page-up",
  modalPageDown: "modal-page-down",
};
